// extracted by mini-css-extract-plugin
export var root = "Hero-module--root--39580";
export var content = "Hero-module--content--96d22";
export var title = "Hero-module--title--b7d95";
export var subtitle = "Hero-module--subtitle--b24ab";
export var ctaButton = "Hero-module--ctaButton--06285";
export var ctaLink = "Hero-module--ctaLink--76de6";
export var header = "Hero-module--header--70b1a";